/* tslint:disable */
/* eslint-disable */
/**
 * cellera-backend API spec
 * Backend Service for Cellera | [swagger.json](cellera/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RegisterDeviceDto
 */
export interface RegisterDeviceDto {
    /**
     * FCM device token
     * @type {string}
     * @memberof RegisterDeviceDto
     */
    fcmToken: string;
    /**
     * Device type
     * @type {string}
     * @memberof RegisterDeviceDto
     */
    deviceType: RegisterDeviceDtoDeviceTypeEnum;
    /**
     * Unique device identifier
     * @type {string}
     * @memberof RegisterDeviceDto
     */
    deviceId?: string;
    /**
     * Device name
     * @type {string}
     * @memberof RegisterDeviceDto
     */
    deviceName?: string;
    /**
     * Device timezone
     * @type {string}
     * @memberof RegisterDeviceDto
     */
    timezone?: string;
}


/**
 * @export
 */
export const RegisterDeviceDtoDeviceTypeEnum = {
    Ios: 'ios',
    Android: 'android',
    Web: 'web'
} as const;
export type RegisterDeviceDtoDeviceTypeEnum = typeof RegisterDeviceDtoDeviceTypeEnum[keyof typeof RegisterDeviceDtoDeviceTypeEnum];


/**
 * Check if a given object implements the RegisterDeviceDto interface.
 */
export function instanceOfRegisterDeviceDto(value: object): value is RegisterDeviceDto {
    if (!('fcmToken' in value) || value['fcmToken'] === undefined) return false;
    if (!('deviceType' in value) || value['deviceType'] === undefined) return false;
    return true;
}

export function RegisterDeviceDtoFromJSON(json: any): RegisterDeviceDto {
    return RegisterDeviceDtoFromJSONTyped(json, false);
}

export function RegisterDeviceDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): RegisterDeviceDto {
    if (json == null) {
        return json;
    }
    return {
        
        'fcmToken': json['fcmToken'],
        'deviceType': json['deviceType'],
        'deviceId': json['deviceId'] == null ? undefined : json['deviceId'],
        'deviceName': json['deviceName'] == null ? undefined : json['deviceName'],
        'timezone': json['timezone'] == null ? undefined : json['timezone'],
    };
}

export function RegisterDeviceDtoToJSON(json: any): RegisterDeviceDto {
    return RegisterDeviceDtoToJSONTyped(json, false);
}

export function RegisterDeviceDtoToJSONTyped(value?: RegisterDeviceDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'fcmToken': value['fcmToken'],
        'deviceType': value['deviceType'],
        'deviceId': value['deviceId'],
        'deviceName': value['deviceName'],
        'timezone': value['timezone'],
    };
}

